import React, { useContext } from "react";
import { ControlContext } from "../../ControlContext.jsx";

import Border from "./Border";
import PasspartoutSegment from "./PasspartoutSegment";
import ChangeDepths from "../../Helpers/ChangeDepths.jsx";

export default function Passpartout({}) {
  const {
    borderWidth,
    borderHeight,
    printWidth,
    printHeight,
    borderThickness,
    borderMaterial,
    borderOffsetX,
    borderOffsetY,
    borderSlit,
  } = useContext(ControlContext);

  const { borderDepth } = ChangeDepths();

  const totalWidth = printWidth + borderWidth * 2;
  const totalHeight = printHeight + borderHeight * 2;

  const slitFill = () => {
    if (borderSlit > 0) {
      return (
        <Border
          borderWidth={borderSlit}
          borderHeight={borderSlit}
          printWidth={printWidth}
          printHeight={printHeight}
          overideColor={"white"}
          borderDepth={borderDepth}
          offset={[0, 0, 0]}
          locationOffset={[borderOffsetX, borderOffsetY, 0]}
        />
      );
    }
  };
  return (
    <>
      <PasspartoutSegment
        totalWidth={totalWidth}
        totalHeight={totalHeight}
        printWidth={printWidth}
        printHeight={printHeight}
        color={borderMaterial[1]}
        bevelColor={borderMaterial[2]}
        borderDepth={borderDepth}
        borderThickness={borderThickness}
        borderSlit={borderSlit}
        offsetX={borderOffsetX}
        offsetY={borderOffsetY}
        rotation={0}
      />
      <PasspartoutSegment
        totalWidth={totalWidth}
        totalHeight={totalHeight}
        printWidth={printWidth}
        printHeight={printHeight}
        color={borderMaterial[1]}
        bevelColor={borderMaterial[2]}
        borderDepth={borderDepth}
        borderThickness={borderThickness}
        borderSlit={borderSlit}
        offsetX={-borderOffsetX}
        offsetY={-borderOffsetY}
        rotation={Math.PI}
      />
      <PasspartoutSegment
        totalWidth={totalHeight}
        totalHeight={totalWidth}
        printWidth={printHeight}
        printHeight={printWidth}
        color={borderMaterial[1]}
        bevelColor={borderMaterial[2]}
        borderDepth={borderDepth}
        borderThickness={borderThickness}
        borderSlit={borderSlit}
        offsetX={borderOffsetY}
        offsetY={-borderOffsetX}
        rotation={Math.PI / 2}
      />
      <PasspartoutSegment
        totalWidth={totalHeight}
        totalHeight={totalWidth}
        printWidth={printHeight}
        printHeight={printWidth}
        color={borderMaterial[1]}
        bevelColor={borderMaterial[2]}
        borderDepth={borderDepth}
        borderThickness={borderThickness}
        borderSlit={borderSlit}
        offsetX={-borderOffsetY}
        offsetY={borderOffsetX}
        rotation={-Math.PI / 2}
      />
      {slitFill()}
    </>
  );
}
